import { render, staticRenderFns } from "./AgencyBook.vue?vue&type=template&id=21edd28c&scoped=true&"
import script from "./AgencyBook.vue?vue&type=script&lang=js&"
export * from "./AgencyBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21edd28c",
  null
  
)

export default component.exports